import { IBackboneResort } from '../types/IBackboneResort';
import { IRawResort } from '../types/IResort';

export default function (resorts: IBackboneResort[]): IRawResort[] {
  return resorts.map((resort) => ({
    id: resort.get('id'),
    name: resort.get('name'),
    country: resort.get('country').get('id'),
    atFiltering: !!resort.get('atFiltering'),
    isPopular: !!resort.get('isPopular'),
  }));
}
